import { RegistrationProfilePeek } from './draw.api';

export interface ProfileDrawProjection {
  id: string;
  displayName: string;
  state: DrawState;
  registration?: RegistrationProfilePeek;
}

export interface DrawRegistrationContextProjection {
  id: string;
  displayName: string;
  state: DrawState;
  facultyAffinity: FacultyAffinity;
  registrationPermittedInfo: RegistrationPermittedInfo;
  maxGroupSize: number | undefined;
  extraTicketConfiguration: ExtraTicketConfiguration | undefined;
}

export type RegistrationPermittedInfo = RegistrationIsPermittedInfo | RegistrationNotPermittedInfo;

export interface RegistrationIsPermittedInfo {
  isAllowed: true;
}

export interface RegistrationNotPermittedInfo {
  isAllowed: false;
  why: RegistrationForbiddenInfo;
}

export type RegistrationForbiddenInfo =
  DefaultRegistrationForbiddenInfo | RegistrationExistsForbiddenInfo | RegistrationInSameSeasonExistsForbiddenInfo;

export interface DefaultRegistrationForbiddenInfo {
  cause: Exclude<
    RegistrationForbiddenCause,
    RegistrationForbiddenCause.RegistrationExists | RegistrationForbiddenCause.RegistrationInSameSeasonExists
  >;
}

export interface RegistrationExistsForbiddenInfo {
  cause: RegistrationForbiddenCause.RegistrationExists;
  registrationId: string;
}

export interface RegistrationInSameSeasonExistsForbiddenInfo {
  cause: RegistrationForbiddenCause.RegistrationInSameSeasonExists;
  conflictingRegistration: {
    registrationId: string;
    drawId: string;
    displayName: string;
  };
}

export type ExtraTicketConfiguration =
  ConstantFactorExtraTicketsConfiguration | ExplicitPerMemberCountExtraTicketsConfiguration;

export interface ConstantFactorExtraTicketsConfiguration {
  classtype: 'constant_factor';
  factor: number;
}

export interface ExplicitPerMemberCountExtraTicketsConfiguration {
  classtype: 'explicit_per_member';
  maxExtraTicketsPerMemberCount: Record<number, number>;
}

export interface DrawTicketContextProjection {
  id: string;
  displayName: string;
  state: DrawState;
  registrationId: string | undefined;
}

export enum RegistrationForbiddenCause {
  RegistrationExists = 'registration.exists',
  RegistrationClosed = 'registration.closed',
  GroupNotAllowed = 'group.notAllowed',
  RegistrationInSameSeasonExists = 'registration.inSameSeasonExists',
}

export interface Draw {
  id: string;
  displayName: string;
  state: DrawState;
  maxGroupSize?: number;
}

export enum DrawState {
  Created = 'created',
  RegistrationOpen = 'registrationOpen',
  RegistrationComplete = 'registrationComplete',
  Drawn = 'drawn',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum FacultyAffinity {
  Maschinenbau = 'maschinenbau',
  Elektrotechnik = 'elektrotechnik',
  Medizin = 'medizin',
}
